import React, { useContext } from 'react';
import GB from 'country-flag-icons/react/3x2/GB'
import NL from 'country-flag-icons/react/3x2/NL'
import DE from 'country-flag-icons/react/3x2/DE'

import GpiLink, { navigate as GpiNavigate } from '../intl/link'
import { IntlContext } from '../intl/intl-context';

export const Languages = {
  en: <><GB title="English" style={{ height: '0.8rem' }}/> English</>,
  nl: <><NL title="Nederlands" style={{ height: '0.8rem' }}/> Nederlands</>,
  de: <><DE title="Deutsch" style={{ height: '0.8rem' }}/> Deutsch</>
}

export function Link(props) {
  const intl = useContext(IntlContext)
  return <GpiLink {...props} hrefLang={props.language || intl.language} />
}

export const navigate = GpiNavigate;

const transMap = {}

export function useLanguage() {
  const intl = useContext(IntlContext)
  if (!(transMap[intl.language])) {
    const f = require("../cms/data")
    transMap[intl.language] = { ...f }
  }
  return {
    trans: transMap[intl.language],
    language: intl.language,
  }
}